// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"564c3144","8694":"017e440e","9782":"d9fc6deb"}[chunkId] + ".chunk.css";
};